/**
 * organMath.js — чистая математика моста «маска→3D». БЕЗ ЕДИНОГО ИМПОРТА —
 * сознательно (приём wlChips/meshConvert): organView тянет toolManager, а
 * тот при импорте требует window — verify такой модуль в node не откроет.
 * Здесь же — только числа, и пины гоняют их на игрушечной маске. [11.1.24]
 */

// ══════════════════════════════════════════════════════════════
//  ЧИСТАЯ МАТЕМАТИКА — без DOM и без cornerstone
// ══════════════════════════════════════════════════════════════

/** Сколько вокселей помечено данным номером сегмента. */
export function подсчётВокселей(данные, индекс) {
  if (!данные?.length) return 0;
  const н = Number(индекс);
  let с = 0;
  for (let i = 0; i < данные.length; i++) if (данные[i] === н) с++;
  return с;
}

/** Объём сегмента в миллилитрах при данном шаге вокселя (мм). */
export function объёмМл(данные, индекс, spacing = [1, 1, 1]) {
  const [sx, sy, sz] = [Number(spacing?.[0]) || 1, Number(spacing?.[1]) || 1, Number(spacing?.[2]) || 1];
  return подсчётВокселей(данные, индекс) * sx * sy * sz / 1000;
}

/** Двоичная копия: 1 там, где стоит номер сегмента, иначе 0 — сырьё для marching cubes по ISO 0.5. */
export function бинаризоватьСегмент(данные, индекс) {
  if (!данные?.length) return null;
  const н = Number(индекс);
  const из = new Uint8Array(данные.length);
  for (let i = 0; i < данные.length; i++) if (данные[i] === н) из[i] = 1;
  return из;
}

/** #rrggbb → [r,g,b] 0…1. Кривой вход — честный серый. */
export function цветВRgb(hex) {
  const м = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
  if (!м) return [0.7, 0.7, 0.7];
  const n = parseInt(м[1], 16);
  return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
}


export default { подсчётВокселей, объёмМл, бинаризоватьСегмент, цветВRgb };
